module.exports = __webpack_public_path__ + "static/media/chewbacca.690b2980.jpg";